<template>
  <div
    :class="[
      'modal-mask',
      {
        'sticky-bottom show': animationStyle == 'slide-up-stick-bottom',
        'modal-mask-v2': hideDefaultModalContainerClass,
      },
      modalClass,
    ]"
    @click.self="closeModal($event)"
    @click.stop
    id="generic-modal-mask-id"
    :style="{
      zIndex: zIndex != null || zIndex != undefined ? zIndex : '',
    }"
  >
    <div
      :class="[
        !hideDefaultModalContainerClass
          ? 'modal-container animated'
          : 'align-items-center flex-row justify-content-center',
      ]"
      :style="{
        width: width,
        height: height,
        maxWidth: width,
        padding: padding,
        background: background,
        bottom: bottom,
        left: left,
      }"
      v-bind:style="modalStyle"
    >
      <div :class="[!!overflowNotNeeded ? 'overflow-hide' : '']">
        <div class="modal-header">
          <slot name="header">
            <!-- <h2 class="modal-default-button" @click="closeModal()">XX</h2> -->
          </slot>
        </div>
        <div
          class="modal-body"
          :class="{ 'modal-content-scroll': contentScroll }"
          :style="[contentScroll && { 'max-height': height }]"
        >
          <slot name="body"></slot>
        </div>

        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "@vue/runtime-core";
import Utility from "../helpers/utility.js";
import setEvents from "../helpers/events";
import PageNames from "../config/pageNames";

export default {
  name: "GenericModal",
  props: [
    "width",
    "height",
    "animationStyle",
    "modalClass",
    "contentScroll",
    "padding",
    "overflowNotNeeded",
    "background",
    "genericModalSource",
    "sectionName",
    "zIndex",
    "bottom",
    "left",
    "hideDefaultModalContainerClass",
    "modalStyle"
  ],
  emits: ["close"],
  setup(props, { emit }) {
    const width = props.width || "",
      height = props.height || "",
      animationStyle = props.animationStyle || "",
      modalClass = props.modalClass || "",
      modalStyle = props.modalStyle || "",
      overflowNotNeeded =
        props.overflowNotNeeded !== undefined ? props.overflowNotNeeded : 1,
      background = props.background;

    const closeModal = (e) => {
      eventFunction(true);
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      // if(props.genericModalSource === 'showLocationPermissionModal' ){
      //   eventFunction2(true);
      // }
      emit("close", e);
    };

    const eventFunction = (isClicked = false, eObj = {}) => {
      if (!props.sectionName) return;
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { actionType: "default dismiss" };
      switch (props.genericModalSource) {
        case "addMinusBtn":
          preEventObj["subCategory"] = "add+";
          preEventObj["screenName"] = "repeat last customisation popup";
          break;
        case "custBtn":
          preEventObj["subCategory"] = "customise";
          preEventObj["screenName"] = "add edit last pizza popup";
          break;
        case "nonCustomization":
          preEventObj["subCategory"] = "banner";
          preEventObj["entryFrom"] = "banner";
          preEventObj["screenName"] = "nextgen non customisation page";
          break;
        default:
          preEventObj["subCategory"] = "default dismiss";
      }

      preEventObj["previousScreenname"] =
        props.sectionName == "searchModal"
          ? PageNames.NEXTGEN_SEARCHPAGE
          : PageNames.NEXTGEN_HOMEPAGE;

      const eventObj = Utility.amplitudeEventObj(
        userAction,
        props.sectionName
          ? props.sectionName == "searchModal"
            ? "search"
            : props.sectionName === "reorder"
            ? "previously ordered items card"
            : props.sectionName.toLowerCase() + " card"
          : "default dismiss",
        props.sectionName
          ? props.sectionName === "reorder"
            ? "4"
            : "11"
          : "11",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    };

    const eventFunction2 = (isClicked = false, eObj = {}) => {
      let eventType = "location_permission_on_home";
      let userAction = isClicked ? "location pop-up dismissed" : "appeared";
      let preEventObj = {
        ...eObj,
        eventCategory: "location permission on home screen",
      };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        undefined,
        undefined,
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    };

    onMounted(() => {
      if (
        document.getElementById("searchQueryInputModal")?.value !== undefined &&
        document.getElementsByClassName("cust-modal-wrap").length == 0
      ) {
        document.getElementById("searchQueryInputModal").focus();
      }

      if (props.genericModalSource === "showLocationPermissionModal") {
        eventFunction2(false);
      }
    });

    return {
      width,
      height,
      animationStyle,
      modalClass,
      closeModal,
      overflowNotNeeded,
      background,
      modalStyle
    };
  },
};
</script>

<style scoped></style>
